/* eslint-disable no-console */
import {Row, Col} from 'antd';
import React from 'react';

import InformativeText from '../../../../constants/InformativeText';
import {accessModule} from '../../../../store/companyStore/companyDetailsStore';
import {convertPxToRem} from '../../../../utils/commonFunctions';
import {shouldBlockModuleAccess} from '../../../../utils/SubscriptionHelper';
import TotalChartList from '../../components/TotalChartList';
import ValueRepresentationBox from '../../components/ValueRepresentationBox';
import {rowGutterNZM} from '../../constants/commonConstants';
import {GHGEmissionDataAsPerSubscription} from '../../constants/commonFunctions';
import {GHGEmissionConst} from '../constants/renderConstants';

const GHGEmission: React.FC<{data: any[]}> = ({data}) => {
  const generalizedInformative = InformativeText?.NZM?.generalized;

  const GHGConstAsPerSubcription = shouldBlockModuleAccess(accessModule.scope3)
    ? GHGEmissionConst.filter((item: any) => {
        return item !== GHGEmissionConst?.[3];
      })
    : GHGEmissionConst;

  return (
    <Row gutter={rowGutterNZM}>
      <Col
        span={8}
        style={{
          height: convertPxToRem(318)
        }}
      >
        <TotalChartList
          data={
            shouldBlockModuleAccess(accessModule.scope3)
              ? GHGEmissionDataAsPerSubscription(data, true)
              : data
          }
          keyArray={GHGConstAsPerSubcription}
          chartType="donut"
        />
      </Col>
      <Col span={4}>
        <ValueRepresentationBox
          data={data}
          mainKey="GHG Emission intensity"
          tooltip={generalizedInformative.GHG_emission_intensity}
        />
      </Col>
      <Col span={4}>
        <ValueRepresentationBox
          data={data}
          mainKey="Total GHG emissions Equity-based"
          tooltip={generalizedInformative.Total_GHG_emission_equity_based}
        />
      </Col>
      <Col span={4}>
        <ValueRepresentationBox
          data={data}
          mainKey="Total GHG emissions Operation-control-based"
          tooltip={
            generalizedInformative.Total_GHG_emission_operation_control_based
          }
        />
      </Col>
      <Col span={4}>
        <ValueRepresentationBox
          data={data}
          mainKey="Total GHG emissions Financial-control-based"
          tooltip={
            generalizedInformative.Total_GHG_emission_financial_control_based
          }
        />
      </Col>
    </Row>
  );
};

export default GHGEmission;
